import * as React from 'react';
require('./style.css');
require('./../style.css');

class CenteredWiderPortalPage extends React.Component<{}, {}> {
	/* RENDER */
	public render() {
		return (
			<div className="centeredPortalPage centeredFullPortalPage">
				<div className="container">{this.props.children}</div>
			</div>
		);
	}
}
export { CenteredWiderPortalPage };
